import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Product } from '@shared/models';
import { ProductThumbnailComponent } from '../../../../shared/product-thumbnail/product-thumbnail.component';

@Component({
    selector: 'app-products-row-type-1',
    templateUrl: './products-row-type-1.component.html',
    styleUrls: ['./products-row-type-1.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ProductThumbnailComponent],
})
export class ProductsRowType1Component {
    @Input({ required: true }) products!: Product[];
}
